import React, { type FC } from 'react'

import type { PartialReadonlyRecord, ReadonlyRecord } from '../../../utils'

import { Translation } from '../../../domain'

import type { AbsoluteRouteOnlyPath } from '../routing'
import { RouteTabs } from '../Tabs'
import { tabs } from './Config'
import { Filter } from './Filter'

const routeTab = {
    documentationTitle: Translation.USERS_AND_ROLES_DOCUMENTATION_TITLE,
    documentationBody: Translation.USERS_AND_ROLES_DOCUMENTATION_BODY,
    titleActions: <Filter />,
} as const

const routeTabs = Object.values(tabs).reduce<PartialReadonlyRecord<AbsoluteRouteOnlyPath, typeof routeTab> & ReadonlyRecord<string, typeof routeTab>>(
    (r, path) => ({ ...r, [path]: routeTab }),
    {}
)

export const UserManagementTabs: FC = () => <RouteTabs title={Translation.USERS_AND_ROLES} tabs={routeTabs} />
